export const MODELS = {
    GPT_3_5_TURBO: 'gpt-3.5-turbo',
    GPT_4: 'gpt-4',
    // GPT_4_TURBO: 'gpt-4-turbo',
    // GPT_4o: 'gpt-4o',
}
